import React from 'react';
import { useTranslation } from '@/hooks/useTranslation.js';
import { Button } from '@/ui/components';

const LanguageSwitch: React.FC = () => {
  const { currentLanguage, switchLanguage } = useTranslation();

  return (
    <div style={{
      position: 'fixed',
      top: '16px', 
      right: '16px',
      zIndex: 1000
    }}>
      <Button
        type="button"
        size="sm"
        variant="secondary"
        onClick={() => switchLanguage(currentLanguage === 'en' ? 'zh' : 'en')}
        iconBefore={<span style={{ fontSize: '16px' }}>{currentLanguage === 'en' ? '🇺🇸' : '🇨🇳'}</span>}
      >
        <span>
          {currentLanguage === 'en' ? 'EN' : '中文'}
        </span>
      </Button>
    </div>
  );
};

export default LanguageSwitch;
